// Reports API Service
import HttpClient from '../http/HttpClient';
import { LEAD_SERVICE_HOST, LEAD_API_PREFIX } from '../constants/RestConstants';
import {
  MonthlySummaryResponse,
  ReportApiResponse
} from '../../models/ReportInterface';

/**
 * Get Monthly Summary Reports
 * GET /api/v1/reports/monthly-summary
 */
export async function getMonthlySummaryReports(): Promise<ReportApiResponse<MonthlySummaryResponse>> {
  const response = await HttpClient.GET({
    BASE_URL: LEAD_SERVICE_HOST,
    END_POINT: `${LEAD_API_PREFIX}/reports/monthly-summary`,
  });
  
  return response;
}

/**
 * Generate Monthly Summary Report
 * POST /api/v1/reports/monthly-summary/generate
 */
export async function generateMonthlySummaryReport(): Promise<ReportApiResponse<MonthlySummaryResponse>> {
  const response = await HttpClient.POST({
    BASE_URL: LEAD_SERVICE_HOST,
    END_POINT: `${LEAD_API_PREFIX}/reports/monthly-summary/generate`,
    data: {},
  });
  
  return response;
}

/**
 * Get monthly summary data for dashboard
 */
export async function getMonthlySummaryData() {
  try {
    const response = await getMonthlySummaryReports();
    return response.data;
  } catch (error) {
    console.error('Error fetching monthly summary data:', error);
    throw error;
  }
}

/**
 * Generate monthly summary data on demand
 */
export async function generateMonthlySummaryData() {
  try {
    const response = await generateMonthlySummaryReport();
    return response.data;
  } catch (error) {
    console.error('Error generating monthly summary data:', error);
    throw error;
  }
}
